import ViewDocument from './ViewDocument';
export default ViewDocument;
